import { Routes } from '@angular/router';
import { ProductComponent } from './product.component';
import { ProductResolver } from './product.resolver';
import { StarRatingConfigService } from 'angular-star-rating';
import { CustomStarRatingConfigService } from './services/custom-star-rating-config.service';

export const PRODUCT_ROUTES: Routes = [
  {
    path: ':url_key',
    component: ProductComponent,
    providers: [
      ProductResolver,
      {
        provide: StarRatingConfigService,
        useClass: CustomStarRatingConfigService,
      },
    ],
    resolve: {
      product: ProductResolver,
    },
    data: { breadcrumb: 'product' },
  },
];
